import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";

import { Button, Divider, Loader, Message } from "semantic-ui-react";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";
import { useUserReload } from "utils/useUserReload";

const LoginWithToken = () => {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const reloadUser = useUserReload();

  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const next = searchParams.get("next");

  let navigateTo = "/";
  let decodedNext: string | null = null;
  if (next) {
    decodedNext = decodeURIComponent(next);
    navigateTo = decodedNext;
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    if (decodedNext) {
      const nextSplit = decodedNext.split("?");
      if (nextSplit.length > 1) {
        const nextParams = new URLSearchParams(nextSplit[1]);
        const utmLinkReferrer = nextParams.get("utm-link");
        if (utmLinkReferrer) {
          dispatch(actions.auth.setUtmLink(utmLinkReferrer));
        }
      }
    }

    api.auth.loginWithToken(
      token,
      () => {
        setLoading(false);
        if (user) {
          reloadUser();
        }
        navigate(navigateTo);
      },
      (err) => {
        setLoading(false);
        setErrorMessage(err.message);
      },
    );
  }, [token, navigateTo, decodedNext, dispatch, navigate, user, reloadUser]);

  if (!token) {
    return <Navigate to={user ? navigateTo : "/"} replace={true} />;
  }

  return (
    <div>
      <h1>{t("entry.login.justAMoment")}</h1>
      <Divider />
      {loading ?
        <div>
          <p>{t("entry.login.token.wait")}</p>
          <Loader active inline="centered" />
          <Divider hidden />
        </div>
      : null}
      {errorMessage ?
        <div>
          <Message color="orange">
            {t("entry.login.token.failed")} {errorMessage}
          </Message>
          <Button as={Link} to="/" primary>
            Return to {user ? "homepage" : "login"}
          </Button>
        </div>
      : null}
    </div>
  );
};

export default LoginWithToken;
